import { BsPersonFill } from "../../../assets/icons/vander";

export const UserMessage = ({ message, timestamp }) => {
  return (
    <div className="user-message">
      <div className="message-bubble">
        <p className="mb-0">{message}</p>
      </div>
      <div className="message-tail"></div>
      <BsPersonFill className="user-avatar" />
      {timestamp && <span className="timestamp">{timestamp}</span>}
    </div>
  );
};
